import React from 'react';
import {
  DefaultEntityFilters,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { Select } from '@backstage/core-components';

import { ApiRoutableFilter } from './filters';

const VALUES = ['vets', 'staff', 'both', 'none'] as const;

type ApiDocsFilters = DefaultEntityFilters & {
  apiRoutable?: ApiRoutableFilter;
};

export const ApiRoutablePicker = () => {
  const { filters, updateFilters } = useEntityList<ApiDocsFilters>();
  const current = filters.apiRoutable?.value ?? '';

  return (
    <Select
      label="Route Type"
      selected={current}
      items={[
        { label: 'All', value: '' },
        ...VALUES.map(v => ({ label: v, value: v })),
      ]}
      onChange={value => {
        const v = String(value ?? '');
        updateFilters({
          apiRoutable: v ? new ApiRoutableFilter(v) : undefined,
        });
      }}
    />
  );
};

